import { GWPContent, GWPGhgContent } from '@retail/products/components';
import { useFetchMgItemGWP } from '@retail/products/data-access';
import { MgItemCard, MgSupplierItemCard, MgSupplierItemClimate } from '@retail/products/types';

interface Props {
  mgItem: MgItemCard;
  selectedSupplierItem: MgSupplierItemCard;
}

export const MgItemGWP = ({ mgItem, selectedSupplierItem }: Props) => {
  const { data: gwpDto } = useFetchMgItemGWP(
    { mgItemNumber: mgItem.mgItemNumber, supplierId: selectedSupplierItem.mgSupplier.mgSupplierId },
    { suspense: false }
  );

  const gwp = MgSupplierItemClimate.fromDto(gwpDto);

  return (
    <>
      <GWPContent data={gwp?.data} />
      <GWPGhgContent data={gwp?.data} />
    </>
  );
};
